import React from 'react';
import { Field, CccisdInput, CccisdToggle } from 'cccisd-formik';
import { widgetBuilder } from 'cccisd-laravel-appdefs';

export const initialValues = {
    show: true,
    title: 'Prizes',
};

const Component = props => {
    return (
        <div>
            <Field name="show" component={CccisdToggle} label="Show Prizes?" />
            <Field name="title" component={CccisdInput} label="Title" />
        </div>
    );
};

export default widgetBuilder({ initialValues })(Component);
